import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit
} from '@angular/core';
import {IMessage} from '../../../services/websocket';
import {TelegramService} from '../../../pages/page-telegram/telegram.service';
import {ModalService} from '../../../services/modal.service';
import {from, Subject, Subscription, takeUntil, throttleTime} from 'rxjs';
import {filter, first} from 'rxjs/operators';
import {isUndefined} from 'util';
import {AllService} from '../../../services/all.service';
import {AllMessengersService} from '../../../pages/page-start/all-messengers.service';
import {Contact, IMessengerConnector} from '../../../types/all.type';
import {AppService} from '../../../services/app.service';
import {InterfaceService} from '../../../services/interface.service';

@Component({
  selector: 'app-online-slider',
  templateUrl: './online-slider.component.html',
  styleUrls: ['./online-slider.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnlineSliderComponent implements OnInit, OnDestroy, OnChanges {
  public isLoaded = false;
  @Input() Service: IMessengerConnector;
  private destroy$: Subject<void> = new Subject();
  isEmpty = false;

  constructor(
    public interfaceService: InterfaceService,
    public appService: AppService,
    public allMessengersService: AllMessengersService,
    private cd: ChangeDetectorRef,
    public allService: AllService,
    public telegramService: TelegramService,
    public modalService: ModalService,
  ) {
  }

  ngOnInit(): void {
    this.cd.reattach();
    this.allService.wsService.on<IMessage>('online').pipe(takeUntil(this.destroy$)).subscribe((data) => {
      let isFind = false;
      from(this.allService.arContacts)
        .pipe(filter((v: any) => v.id === data.user_id && v.service_type === data.path))
        .subscribe((contact: any) => {
          if (!data.online) {
            setTimeout(() => {
              contact.online = false;
            }, 60000);
          } else {
            contact.online = true;
          }
          contact.last_seen = data.last_seen;
          isFind = true;
        });
      if (isFind) {
        this.contactsResort();
        this.allService.saveLocalContacts();
        this.cd.detectChanges();
      }
    });
    this.init();
  }

  contactsResort(): void {
    this.allService.arContacts = this.appService.onlineSort(this.allService.arContacts || []);
  }

  init() {
    if (this.arContacts?.length === 0) {
      this.loadContacts();
    } else {
      this.isLoaded = true;
      this.cd.detectChanges();
      if (this.Service.type === 'all') {
        this.loadContacts(3000);
      } else {
        this.loadContacts(15000);
      }
    }
    setTimeout(() => {
      // window.dispatchEvent(new Event('resize'));
    }, 1000);
  }

  loadContacts(timeout = 0) {
    this.allService.loadedChats$.pipe(takeUntil(this.destroy$), throttleTime(3000), first()).subscribe(() => {
      this.allMessengersService.contactsList('', '', 30).pipe(takeUntil(this.destroy$)).subscribe(
        (result: any) => {
          this.allMessengersService.mergeContacts(result.results);
          if (this.Service.type !== 'all') {
            result.results.map((v) => (v.service_type = this.Service.type));
          }
          this.contactsResort();
          this.allService.saveLocalContacts();
          this.isLoaded = true;
          if (result.results?.length === 0) {
            this.isEmpty = true;
          }
          this.cd.detectChanges();
          // window.dispatchEvent(new Event('resize'));
        },
        (error) => {
          this.interfaceService.errorHandling(error);
        }
      );
    });
  }

  openDetail(client: any) {
    client.type = 'private';
    client.members = [];
    let Service = this.Service;
    Service = this.allMessengersService.getService(client.service_type) || Service;
    this.modalService.openModal('ModalChatDetailComponent', {
      Service,
      id: client.id,
      initData: client
    });
  }

  get arContacts(): Contact[] {
    if (!(this.Service instanceof AllMessengersService)) {
      return this.allService.arContacts.filter((v) => v.service_type === this.Service.type);
    } else {
      return this.allService.arContacts;
    }
  }

  ngOnChanges(): void {
    // window.dispatchEvent(new Event('resize'));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get runChangeDetection() {
    this.allService.arDetectChangesLog.OnlineSliderComponent++;
    return '';
  }

  visible(visible) {
    if (visible) {
      // window.dispatchEvent(new Event('resize'));
    }
  }
}
